import axios from "axios";
import { baseUrl } from "../config/api-config";
import { buildQuery } from "../config/api-config";

export const getReports = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/reports/ticketfilter${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
  });
};

export const getExcelViewer = (query, token) => {
  let qs = buildQuery(query);
  let url = `${baseUrl}/ticketexporttoexcel${qs}`;
  return axios.get(url, {
    headers: {
      authorization: token,
    },
    responseType: "blob",
  });
};
